import { Component } from "@angular/core";
import { MatProgressSpinner } from "@angular/material/progress-spinner";
import { TranslatePipe } from "@ngx-translate/core";

@Component({
  selector: "app-migration-in-progress",
  imports: [MatProgressSpinner, TranslatePipe],
  standalone: true,
  templateUrl: "./migration-in-progress.component.html",
  styleUrl: "./migration-in-progress.component.scss",
})
export class MigrationInProgressComponent { }
